import { render } from "./WhyChoiceForYou.vue?vue&type=template&id=6d4a116c&scoped=true"
import script from "./WhyChoiceForYou.vue?vue&type=script&lang=js"
export * from "./WhyChoiceForYou.vue?vue&type=script&lang=js"

import "./WhyChoiceForYou.vue?vue&type=style&index=0&id=6d4a116c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4a116c"]])

export default __exports__